import { StatusDivida, StatusProposta } from '@/models/enums';
import { IDivida } from '@/models/IDivida';
import { IPromessa } from '@/models/IPromessa';
import { DividaResource } from '@/models/resources';
import sessionService from './SessionService';

type DividaRouteName = 'ofertas' | 'boletos' | 'proposta-aceita' | 'proposta-em-analise';

export function getRouteName(
  divida: DividaResource,
  proposta?: IPromessa,
  emNegociacao = false,
): DividaRouteName | null {
  /*
  Esta função foi importada da vuex action termometro/redirecionarRota do v2.

  Pelo comportamento da v2, o param emNegociacao é false quando vem da url de dívida (componente
  /pages/divida/_credor/_id/new-index.vue) e true quando vem do termometro (vuex action
  termometro/observarDivida).
  */

  if (
    proposta?.status === StatusProposta.PendenteDeRetorno
    || proposta?.status === StatusProposta.EmAnalise
  ) {
    return 'proposta-em-analise';
  }

  if (proposta?.status === StatusProposta.Aceita) {
    return emNegociacao ? 'proposta-aceita' : 'boletos';
  }

  if (proposta?.status === StatusProposta.Recusada && emNegociacao) {
    return divida.possuiOferta ? 'ofertas' : null;
  }

  if (divida.status === StatusDivida.Bloqueada) {
    return divida.possuiOferta ? 'ofertas' : null;
  }

  if (divida.possuiOferta) {
    return 'ofertas';
  }

  return null;
}

export function acessoPrecisa2FA(divida: IDivida): boolean {
  return divida.ofuscada && !sessionService.is2faAuthorized;
}

export default { getRouteName, acessoPrecisa2FA };
